// jshint esversion: 6
let _CLIENT_ID, _API_KEY, _AUTHORIZATION, _DRIVE_CLIENT_ID;
if (process.env.NODE_ENV === "development") {
	_CLIENT_ID = "13656";
	_API_KEY = "60cd936e5bfe45f4afa19518d5998e6d";
	_AUTHORIZATION = "MTM2NTY6Ui4yTTk5OTh0RVNRVHA4Ym51T01meUkyMWhlS21QTFhSQW8zWTduYUVWRQ==";
	_DRIVE_CLIENT_ID = '417718484181-ghd3ck01fegicijuft90bfvvs7vgnfk1.apps.googleusercontent.com';
} else if (process.env.NODE_ENV === "web") {
	_CLIENT_ID = "13656";
	_API_KEY = "60cd936e5bfe45f4afa19518d5998e6d";
	_AUTHORIZATION = "MTM2NTY6Ui4yTTk5OTh0RVNRVHA4Ym51T01meUkyMWhlS21QTFhSQW8zWTduYUVWRQ==";
	_DRIVE_CLIENT_ID = '417718484181-uu4oamajr8ifirmdor074900du2meefq.apps.googleusercontent.com';
} else {
	_CLIENT_ID = "21268";
	_API_KEY = "dc6cbc134270468581259fb7edf0aa0f";
	_AUTHORIZATION = "MjEyNjg6Tzh1eTRDUldUSktkc1Atd2hDcm9qMnNzNW1lUVAtZ3RGNS11ZktuVFNvWQ==";
	_DRIVE_CLIENT_ID = '417718484181-8ju8qopfvn4q4fioo87k7utgs7bdlrps.apps.googleusercontent.com';
}
export const CLIENT_ID = _CLIENT_ID;
export const API_KEY = _API_KEY;
export const AUTHORIZATION = _AUTHORIZATION;
export const DRIVE_CLIENT_ID = _DRIVE_CLIENT_ID;


// WEBPACK FOOTER //
// ./src/shared/private.js